import angular from 'angular';

import RadioModule from './radio';
import CheckboxModule from './checkbox';
import CheckmarkModule from './checkmark';
import TimeModule from './time';
import DateModule from './date';
import DatePickerModule from './date-picker';
import OptionSelectModule from './option-select';
import SwitchModule from './switch';
import ValidationMessageModule from './validation-message';
import UserImageModule from './user-image';
import PrettyNumberModule from './pretty-number';
import NotificationsModule from './notifications';
import ModalsModule from './modals';
import CookieNotificationModule from './cookie-notification';
import SearchModule from './search';
import TeamRadioModule from './team-radio';
import CalendarCheckboxModule from './calendar-checkbox';
import CalendarRadioModule from './calendar-radio';
import CategoryIconModule from './category-icon';
// import SelectModule from './select';
// import MultipleSelectModule from './multiple-select';
import DateRangePickerModule from './date-range-picker';
import ChangeLogModule from './change-log';

export default angular
    .module('application.component', [
        RadioModule.name,
        CheckboxModule.name,
        CheckmarkModule.name,
        TimeModule.name,
        DateModule.name,
        DatePickerModule.name,
        OptionSelectModule.name,
        SwitchModule.name,
        ValidationMessageModule.name,
        UserImageModule.name,
        PrettyNumberModule.name,
        NotificationsModule.name,
        ModalsModule.name,
        CookieNotificationModule.name,
        SearchModule.name,
        TeamRadioModule.name,
        CalendarCheckboxModule.name,
        CalendarRadioModule.name,
        CategoryIconModule.name,
        // SelectModule.name,
        // MultipleSelectModule.name,
        DateRangePickerModule.name,
        ChangeLogModule.name
    ]);



// WEBPACK FOOTER //
// ./src/application/component/index.js